import React from "react";
import { Popover } from "@clarkinc/zest-design-system";
import { cls } from "cls";
import { ClientOnly } from "@wss/react";

interface Props {
  stockMessage: string;
  restrictItemExpeditedShipping: boolean;
}

const ShippingMessage = ({
  stockMessage,
  restrictItemExpeditedShipping,
}: Props) => {
  return (
    <>
      <div
        className={cls(
          "relative",
          "flex",
          "w-full",
          "max-w-sm",
          "mb-4",
          "bg-white",
        )}
      >
        <img
          className={cls("w-10", "h-10", "m-auto", "mx-0", "mr-2")}
          src="/uploads/design/2022/7/icon_shipping.svg"
          alt=""
        />
        <div>
          {stockMessage.length > 0 &&
          stockMessage.toLowerCase().includes("usually ships in") ? (
            <p className={cls("m-0")}>
              {stockMessage.slice(0, 17)}
              <span className="font-bold">{stockMessage.slice(17)} </span>
              from manufacturer
            </p>
          ) : (
            <p className={cls("m-0")}>{stockMessage}</p>
          )}

          <p className="m-0 text-gray-700 text-xs inline">
            Lead times vary based on manufacturer stock
          </p>
          <ClientOnly>
            <Popover>
              <Popover.Trigger
                contentId="extended-shipping-popover"
                className="more-info popover-dismiss ml-1 text-sm leading-4 text-green-500 hover:text-green-700 inline"
              >
                <i className="icon-question" aria-hidden="true" />
                <span className="sr-only">Estimated shipping time</span>
              </Popover.Trigger>
              <Popover.Content
                id="extended-shipping-popover"
                title="Estimated Shipping Time"
              >
                Because this item ships directly from the manufacturer, we
                cannot guarantee stock availability or lead time. If you need
                your items by a certain date, please contact us prior to placing
                your order. Expedited shipping availability may vary. We cannot
                guarantee that this item can be cancelled off of the order or
                returned once it is placed.
              </Popover.Content>
            </Popover>
          </ClientOnly>
        </div>
      </div>
      {restrictItemExpeditedShipping && (
        <p>Not eligible for expedited shipping</p>
      )}
    </>
  );
};

export default ShippingMessage;
